import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { Table, TableCell, TableContainer, TableRow, TableHead, TableBody, Box, FormControl, Select, MenuItem, Button, CircularProgress } from '@mui/material';
import { getReportCountMntTaskGroupByCtgr1AndSubwayLineByQuery, getReportCountMntTaskGroupByCtgr1ByQuery, getReportCountQuarterlyMntTaskGroupByCtgr1ForTwoYearsByQuery, getReportCountYearlyMntTaskGroupByCtgr1ForTwoYearsByQuery } from "components/axios/reportAxios";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import PieChart from "components/inner/chart/PieChart";
import CommonExcelDownload from "components/CommonExcelDownload";
import InDecreaseExcelDownload from "components/InDecreaseExcelDownload";
import CustomReportSelect from "components/select/CustomReportSelect";
import { reverseOrderNumber } from "data/data";
import BarChart from "components/inner/chart/BarChart";
import { useEffect } from "react";
import CustomDatePicker2 from "components/date_picker/CustomDatePicker2";

const ComprehensiveReportReportDataroomMaintenenceReport = () => {
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
               // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const today = dayjs(new Date()).format('YYYY-MM-DD');
    const curYear = dayjs(new Date()).format("YYYY");
    const [searchParams, setSearchParams] = useState([{code:"cy", title:t('message.common.select.current.year')},{code:"cy1", title:t('message.common.select.current.year.first.quarter')},{code:"cy2", title:t('message.common.select.current.year.second.quarter')},{code:"cy3", title:t('message.common.select.current.year.third.quarter')},{code:"cy4", title:t('message.common.select.current.year.fourth.quarter')},
    {code:"oy", title:t('message.common.select.last.year')},{code:"oy1", title:t('message.common.select.last.year.first.quarter')},{code:"oy2", title:t('message.common.select.last.year.second.quarter')},{code:"oy3", title:t('message.common.select.last.year.third.quarter')},{code:"oy4", title:t('message.common.select.last.year.fourth.quarter')}]);
    const [searchParam, setSearchParam] = useState({code:"cy", title:t('message.common.select.current.year')});
    const [search, setSearch] = useState('');

    const [searchStartDateText, setSearchStartDateText] = useState(today);
    const [searchEndDateText, setSearchEndDateText] = useState(today);

    const [pieDatas, setPieDatas] = useState([]);
    const [barData, setBarData] = useState(null);

    const [reportTitle, setReportTitle] = useState("");

    const [fileName, setFileName] = useState("");
    const [reports, setReports] = useState([]);
    const [excelDatas, setExcelDatas] = useState([]);
    const excelTopHeaders = [t('message.common.subtitle.main.category'), t('message.common.subtitle.total.count'), t('message.common.subtitle.one.subwayline'), t('message.common.subtitle.two.subwayline')];

    const [fileName2, setFileName2] = useState("");
    const [report2s, setReport2s] = useState([]);
    const [excelData2s, setExcelData2s] = useState([]);
    const [excelTopHeader2s, setExcelTopHeader2s] = useState([]);
    const [excelTopHeader22s, setExcelTopHeader22s] = useState([]);

    useEffect(()=>{
        let years = [];
        for(let i=2020 ; i<=parseInt(curYear)-2 ; i++) {
          years.push(i)
        }
        reverseOrderNumber(years);

        let searchParamsCopy = [...searchParams];
        years.map((item, i)=>{
            searchParamsCopy.push({code:"yy"+item, title: item})
        })
        setSearchParams(searchParamsCopy);
    },[]);

    const selectParam = () => {
        if (search === null || search === '') {
            alertMessage = t('message.common.alert.period.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (search && search !== '') {
            let params = search.split(',');
            let searchParam = {code:params[0],title:params[1]};
            setSearchParam(searchParam);
            
            let year = searchParam.code.indexOf("cy") !== -1 ? curYear: searchParam.code.indexOf("oy") !== -1 ? curYear-1 : searchParam.code.indexOf("yy") !== -1 ? searchParam.code.replace('yy',''):'';
            let quarter = null;
            if (searchParam.code.indexOf("yy") === -1) {
                quarter = searchParam.code.replace("cy","").replace("oy","");
            }
            let param = {year};
            if (quarter)
                param.quarter = quarter;

            let topHeader2s = [t('message.common.subtitle.main.category'), year+t('message.common.title.year')+(quarter?" "+quarter+t('message.common.select.quarter'):"")];
            
            if (quarter) {  // 분기 선택
                if (parseInt(quarter) === 1) {
                    topHeader2s.push((year-1).toString().concat(t('message.common.title.year')," ","4"+t('message.common.select.quarter')));
                } else {
                    topHeader2s.push((year).toString().concat(t('message.common.title.year')," ",(quarter-1),t('message.common.select.quarter')));
                }
                topHeader2s.push("");
                topHeader2s.push("");
                topHeader2s.push((year-1).toString().concat(t('message.common.title.year')," ",quarter,t('message.common.select.quarter')));
                topHeader2s.push("");
                topHeader2s.push("");
            } else {
                topHeader2s.push((year-1).toString().concat(t('message.common.title.year')));
                topHeader2s.push("");
                topHeader2s.push("");
                topHeader2s.push("");
                topHeader2s.push("");
                topHeader2s.push("");
            }
            setExcelTopHeader2s(topHeader2s);

            let topHeader22s = ["", ""];
            topHeader22s.push(t('message.common.subtitle.count'));
            topHeader22s.push(t('message.common.subtitle.increase.decrease.count'));
            topHeader22s.push(t('message.common.subtitle.increase.decrease.rate'));
            if (quarter) {  // 분기 선택
                topHeader22s.push(t('message.common.subtitle.count'));
                topHeader22s.push(t('message.common.subtitle.increase.decrease.count'));
                topHeader22s.push(t('message.common.subtitle.increase.decrease.rate'));
            } else {
                topHeader22s.push("");
                topHeader22s.push("");
                topHeader22s.push("");
            }
            setExcelTopHeader22s(topHeader22s);

            let title = year+t('message.common.title.year');
            if (quarter) {
                title += " "+quarter+t('message.common.select.quarter');
            }
            title += " "+t('message.common.title.comprehensive.report');
            setReportTitle(title);

            Promise.all([
                getReportCountMntTaskGroupByCtgr1ByQuery(param).then((data)=>{
                    if(data && data.length > 0) {
                        let pieDatas = [];
                        let pieData = {};
                        data.forEach((element, i) =>{
                            pieData = {};
                            pieData.title = element[0];
                            pieData.cnt = element[1] ? element[1] : 0;
                            pieDatas.push(pieData);
                        })
                        let pieChartDatas = pieDatas;
                        if (pieDatas.length > 5) {
                            let copyStartPieDatas = pieDatas.slice(0,5);
                            let copyEndPieDatas = pieDatas.slice(5);

                            // const sum = copyEndPieDatas.reduce((accumulator, currentValue) => {
                            //     return accumulator + currentValue[2]
                            // }, 0);

                            copyStartPieDatas.push({title:t('message.common.etc.equipment'), cnt:
                                copyEndPieDatas.reduce((accumulator, currentValue) => {
                                    return accumulator + currentValue.cnt
                                }, 0)
                            })

                            pieChartDatas = copyStartPieDatas;
                        }
                        
                        setPieDatas(pieChartDatas);
                    } else {
                        setPieDatas([]);
                    }
                }),
                getReportCountMntTaskGroupByCtgr1AndSubwayLineByQuery(param).then((data)=>{
                    if(data && data.length > 0) {
                        setReports(data);

                        let excelDatas = [];
                        let excelData = [];
                        data && data.forEach(function(column, a) {
                            excelData = [];
                            let sum = column[1]+column[2];
                            excelTopHeaders.forEach(function(hd, b) {
                                let value = column[b];
                                if (b===1) {
                                    value = sum;
                                } else if (b>1) {
                                    value = column[b-1];
                                }
                                excelData.push(value);
                            })
                            excelDatas.push(excelData);
                        })
                        setExcelDatas(excelDatas);

                        let barDatas = [...excelDatas];
                        reverseOrderNumber(barDatas, 1)
                        let barChartDatas = barDatas;
                        if (barDatas.length > 5) {
                            let copyStartBarDatas = barDatas.slice(0,5);
                            let copyEndBarDatas = barDatas.slice(5);

                            // const sum = copyEndBarDatas.reduce((accumulator, currentValue) => {
                            //     // return accumulator + currentValue[2]
                            //     return accumulator + currentValue[1]
                            // }, 0);

                            copyStartBarDatas.push([t('message.common.etc.equipment'),
                                copyEndBarDatas.reduce((accumulator, currentValue) => {
                                    return accumulator + currentValue[1]
                                }, 0),
                                copyEndBarDatas.reduce((accumulator, currentValue) => {
                                    return accumulator + currentValue[2]
                                }, 0),
                                copyEndBarDatas.reduce((accumulator, currentValue) => {
                                    return accumulator + currentValue[3]
                                }, 0),
                                // copyEndBarDatas.reduce((accumulator, currentValue) => {
                                //     return accumulator + currentValue[4]
                                // }, 0)
                            ])

                            barChartDatas = copyStartBarDatas;
                        }
                        let series = [{name:t('message.common.subtitle.one.subwayline'),data:[]},{name:t('message.common.subtitle.two.subwayline'),data:[]},{name:t('message.common.subtitle.total.count'),data:[]}];
                        let categories = [];
                        barChartDatas && barChartDatas.forEach(function(column, a) {
                            series[0].data.push(column[2]);
                            series[1].data.push(column[3]);
                            // series[2].data.push(column[4]);
                            // series[3].data.push(column[1]);
                            series[2].data.push(column[1]);
                            categories.push(column[0]);
                        })
                        let barData = {series, categories};
                        setBarData(barData);
                    } else {
                        setReports([]);
                        setExcelDatas([]);
                        setBarData(null);
                    }
                })
            ]).then(()=>{
                setFileName(t('message.common.file.name.maintenance.analysis.report')+"_"+year+t('message.common.title.year')+"_"+(quarter ? quarter+t('message.common.select.quarter')+"_":"")+t('message.common.title.comprehensive.report')+"_"+t('message.common.file.name.statistics')+"_" + Date.now());
                setFileName2(t('message.common.file.name.maintenance.analysis.report')+"_"+year+t('message.common.title.year')+"_"+(quarter ? quarter+t('message.common.select.quarter')+"_":"")+t('message.common.title.comprehensive.report')+"_"+t('message.common.file.name.increase.decrease')+"_" + Date.now());
                if (quarter) {  // 분기 선택한 경우
                    getReportCountQuarterlyMntTaskGroupByCtgr1ForTwoYearsByQuery(param).then((data)=>{
                        if(data) {
                            let data2 = data && data.map(function(column, a) {
                                let val1 = column[2]+","+(column[1]-column[2]);
                                if ((column[1]-column[2]) !== 0 && column[1] !== 0) {
                                    val1 += ","+((column[1]-column[2])/column[1]*100).toFixed(1)+"%";
                                } else {
                                    val1 += ",";
                                }

                                column[2] = val1;
                                let val2 = column[3]+","+(column[1]-column[3]);
                                if ((column[1]-column[3]) !== 0 && column[1] !== 0) {
                                    val2 += ","+((column[1]-column[3])/column[1]*100).toFixed(1)+"%";
                                } else {
                                    val2 += ",";
                                }

                                column[3] = val2;
                                return column
                            })
                            let excelDatas = [];
                            let excelData = [];
                            data2 && data2.forEach(function(column, a) {
                                excelData = [];
                                topHeader2s.forEach(function(hd, b) {
                                    if (b < topHeader2s.length-6) {
                                        excelData.push(column[b]);
                                    } else {
                                        if (b === (topHeader2s.length-6) || b === (topHeader2s.length-5)) {
                                            let temp = column[b].split(",");
                                            temp && temp.forEach(function(d, ti) {
                                                excelData.push(d);
                                            })
                                        }
                                    }
                                })
                                excelDatas.push(excelData);
                            })
                            setReport2s(data2);
                            setExcelData2s(excelDatas);
                        } else {
                            setReport2s([]);
                            setExcelData2s([]);
                        }
                    })
                } else {    // 년도만 선택된 경우
                    getReportCountYearlyMntTaskGroupByCtgr1ForTwoYearsByQuery(param).then((data)=>{
                        if(data) {
                            let data2 = data && data.map(function(column, a) {
                                let val1 = column[2]+","+(column[1]-column[2]);
                                if ((column[1]-column[2]) !== 0 && column[1] !== 0) {
                                    val1 += ","+((column[1]-column[2])/column[1]*100).toFixed(1)+"%";
                                } else {
                                    val1 += ",";
                                }
                                column[2] = val1;

                                let val2 = ",,";
                                column[3] = val2;
                                return column
                            })
                            let excelDatas = [];
                            let excelData = [];
                            data2 && data2.forEach(function(column, a) {
                                excelData = [];
                                topHeader2s.forEach(function(hd, b) {
                                    if (b < topHeader2s.length-6) {
                                        excelData.push(column[b]);
                                    } else {
                                        if (b === (topHeader2s.length-6) || b === (topHeader2s.length-5)) {
                                            let temp = column[b].split(",");
                                            temp && temp.forEach(function(d, ti) {
                                                excelData.push(d);
                                            })
                                        }
                                    }
                                })
                                excelDatas.push(excelData);
                            })
                            setReport2s(data2);
                            setExcelData2s(excelDatas);
                        } else {
                            setReport2s([]);
                            setExcelData2s([]);
                        }
                    })
                }
            })
        }
    }

    return (
        <div>
            <div>
                <Box sx={{ minWidth: 120 }}>
                    {searchParams && 
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <CustomReportSelect
                            key={'period'}
                            label={t('message.common.select.period')}
                            name={'period'}
                            defaultValue={search}
                            onChange={(e)=>{
                                setSearch(e.target.value);
                            }}
                            list={searchParams}
                        />
                    </FormControl>
                    }
                    
                    <Link to={''}><Button variant="contained" style={{marginTop:"13px",padding:"5px 15px"}} onClick={selectParam}>{t('message.common.btn.report.generation')}</Button></Link>
                </Box>

                {((reports && reports.length > 0) || (report2s && report2s.length > 0)) &&
                <div>
                    <p className="report-dataroom-tit">
                        {reportTitle}
                    </p>
                    <div style={{display: "flex",justifyContent:"center"}}>
                        {pieDatas && pieDatas.length > 0 && <PieChart pieDatas={pieDatas} />}
                        {barData && <BarChart barData={barData} />}
                    </div>

                    <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.title.maintenance.statistics')}</p>
                    <TableContainer>
                        <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('message.common.subtitle.main.category')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.total.count')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.one.subwayline')}</TableCell>
                                    <TableCell>{t('message.common.subtitle.two.subwayline')}</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                            { reports && reports.map(function(item, i) {
                                let sum = item[1] + item[2];
                                return (
                                <TableRow key={i}>
                                    <TableCell>{item[0]}</TableCell>
                                    <TableCell>{sum}</TableCell>
                                    <TableCell>{item[1]}</TableCell>
                                    <TableCell>{item[2]}</TableCell>
                                </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <br/>

                    {(excelDatas && excelDatas.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page'>
                            <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelTopHeaders} title={`${reportTitle} ${t('message.common.title.maintenance.statistics')}`} filename={`${fileName}.xlsx`} />
                        </div>
                    </div>
                    :
                    (reports && reports.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page' style={{color:"#000"}}>
                            <Box sx={{ display: 'flex', color:"#000" }}>
                                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                            </Box>
                        </div>
                    </div>
                    : ''
                    }

                    <p className="report-dataroom-subtit"><span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;{t('message.common.title.maintenance.increase.decrease')}</p>
                    <TableContainer>
                        <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table">
                            <TableHead>
                                <TableRow>
                                {excelTopHeader2s && excelTopHeader2s.map(function(hd, b) {
                                    if (b < (excelTopHeader2s.length-6)) {
                                        return (
                                    <TableCell key={b} rowSpan={2}>{hd}</TableCell>
                                        )
                                    } else if (b == (excelTopHeader2s.length-6) || b == (excelTopHeader2s.length-3)) {
                                        return (
                                    <TableCell key={b} colSpan={3}>{hd}</TableCell>
                                        )
                                    }
                                })}
                                </TableRow>
                                <TableRow>
                                {excelTopHeader22s && excelTopHeader22s.map(function(hd, b) {
                                    if (b >= (excelTopHeader22s.length-6)) {
                                        return (
                                    <TableCell key={b}>{hd}</TableCell>
                                        )
                                    }
                                })}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                            { excelData2s && excelData2s.map(function(item, i) {
                                // console.log(item)
                                 let color1 = "red2", color2 = "red2";
                                 if (item[3].indexOf("-") !== -1) {
                                     color1 = "blue";
                                 }
                                 if (item[6].indexOf("-") !== -1) {
                                     color2 = "blue";
                                 }
                                return (
                                <TableRow key={i}>
                                    <TableCell>{item[0]}</TableCell>
                                    <TableCell>{item[1]}</TableCell>
                                    <TableCell className={color1}>{item[2]}</TableCell>
                                    <TableCell className={color1}>{item[3]}</TableCell>
                                    <TableCell className={color1}>{item[4]}</TableCell>
                                    <TableCell className={color2}>{item[5]}</TableCell>
                                    <TableCell className={color2}>{item[6]}</TableCell>
                                    <TableCell className={color2}>{item[7]}</TableCell>
                                </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {(excelData2s && excelData2s.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page'>
                            <InDecreaseExcelDownload excelDatas={excelData2s} excelHeader={excelTopHeader2s} excelHeader2={excelTopHeader22s} title={`${reportTitle} ${t('message.common.title.maintenance.increase.decrease')}`} filename={`${fileName2}.xlsx`} />
                        </div>
                    </div>
                    :
                    (report2s && report2s.length > 0) ?
                    <div className="report-dataroom-button">
                        <div></div>
                        <div className='no-print-page' style={{color:"#000"}}>
                            <Box sx={{ display: 'flex', color:"#000" }}>
                                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                            </Box>
                        </div>
                    </div>
                    : ''
                    }

                </div>
                }
            </div>       
        </div>
    )

}

export default ComprehensiveReportReportDataroomMaintenenceReport;